import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '../services/api';
import { useGlobalLoader } from '../components/TimchehLoaderProvider';
import toast from 'react-hot-toast';

interface ForgotPasswordForm {
  email: string;
}

const ForgotPasswordPage: React.FC = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { showLoader, hideLoader } = useGlobalLoader();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm<ForgotPasswordForm>();

  const onSubmit = async (data: ForgotPasswordForm) => {
    try {
      showLoader({ message: 'در حال ارسال لینک بازنشانی...', fullScreen: true });
      
      await authApi.forgotPassword(data.email);
      
      hideLoader();
      setIsSubmitted(true);
      toast.success('لینک بازنشانی رمز عبور به ایمیل شما ارسال شد');
    } catch (error: any) {
      hideLoader();
      const errorMessage = error.response?.data?.message;
      toast.error(errorMessage || 'ارسال لینک بازنشانی ناموفق بود');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" dir="rtl">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            فراموشی رمز عبور
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            آدرس ایمیل خود را وارد کنید و ما یک لینک برای بازنشانی رمز عبور برای شما ارسال می‌کنیم
          </p>
        </div>

        {!isSubmitted ? (
          <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                آدرس ایمیل
              </label>
              <input
                {...register('email', {
                  required: 'ایمیل الزامی است',
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'لطفاً یک آدرس ایمیل معتبر وارد کنید'
                  }
                })}
                type="email"
                className="mt-1 appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm"
                placeholder="آدرس ایمیل خود را وارد کنید"
              />
              {errors.email && (
                <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>
              )}
            </div>

            <div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'در حال ارسال...' : 'ارسال لینک بازنشانی'}
              </button>
            </div>

            <div className="text-center">
              <Link
                to="/login"
                className="text-sm font-medium text-primary-600 hover:text-primary-500"
              >
                بازگشت به ورود ←
              </Link>
            </div>
          </form>
        ) : (
          <div className="mt-8 space-y-6 text-center">
            <div className="bg-green-50 border border-green-200 rounded-md p-4">
              <p className="text-sm text-green-800">
                اگر حسابی با آن ایمیل وجود داشته باشد، لینک بازنشانی رمز عبور ارسال شده است.
                لطفاً ایمیل خود را بررسی کنید و روی لینک کلیک کنید تا رمز عبور خود را بازنشانی کنید.
              </p>
            </div>
            <div>
              <Link
                to="/login"
                className="text-sm font-medium text-primary-600 hover:text-primary-500"
              >
                بازگشت به ورود ←
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;

